export default __webpack_public_path__ + "static/media/CoBrand-Fintech-lab.b2eb1548.jpg";